// src/components/BottomNavigation.js - 모바일 하단 네비게이션 바
import React from 'react';
import { Home, BookOpen, Edit, Target, User } from 'lucide-react';

const BottomNavigation = ({ currentPage, setCurrentPage, user }) => {
  const navItems = [
    { id: 'home', label: 'Bluebook Go', icon: Home, alwaysBlue: true },
    { id: 'online_test', label: '온라인', icon: BookOpen },
    { id: 'review', label: '복습', icon: Edit },
    { id: 'bluebook', label: '자료', icon: Target },
    { id: 'dashboard', label: 'My', icon: User }
  ];

  return (
    <nav className="xl:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50 safe-area-bottom">
      <div className="flex justify-around items-center h-16 px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = currentPage === item.id;

          return (
            <button
              key={item.id}
              onClick={() => setCurrentPage(item.id)}
              className={`flex flex-col items-center justify-center flex-1 h-full space-y-1 transition-colors ${
                item.alwaysBlue
                  ? 'text-blue-600'
                  : isActive
                    ? 'text-blue-600'
                    : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              <Icon
                size={22}
                strokeWidth={item.alwaysBlue || isActive ? 2.5 : 2}
              />
              <span className={`text-xs ${item.alwaysBlue || isActive ? 'font-semibold' : 'font-medium'}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigation;
